import { useAuthors } from '@/hooks/use-sheets-data';
import { useScrollNavigation } from '@/hooks/use-scroll';
import { Card, CardContent } from "@/components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

export function AuthorList() {
  const { data: authors = [], isLoading, error } = useAuthors();
  const { navigateAndScroll } = useScrollNavigation();

  if (isLoading) {
    return <div className="p-4">Loading authors...</div>;
  }

  if (error) {
    return <div className="p-4 text-red-500">Error: {error.message}</div>;
  }

  if (!authors?.length) {
    return <div className="p-4">No authors found.</div>;
  }

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-6">Authors</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {authors.map((author) => (
          <div 
            key={author.id} 
            className="cursor-pointer"
            onClick={() => navigateAndScroll(`/authors/${author.slug}`)}
          >
            <Card className="h-full overflow-hidden hover:shadow-lg transition-shadow">
              <CardContent className="p-4">
                <div className="flex items-center space-x-4">
                  <Avatar className="h-16 w-16">
                    <AvatarImage
                      src={author.picture}
                      alt={author.name}
                      className="object-cover"
                    />
                    <AvatarFallback className="text-lg">
                      {author.name.split(' ').map(n => n[0]).join('')}
                    </AvatarFallback>
                  </Avatar>
                  <div>
                    <h2 className="text-xl font-bold">{author.name}</h2>
                    <p className="text-sm text-gray-600">
                      {author.books?.length || 0} books
                    </p>
                  </div>
                </div>
                {author.bio && (
                  <p className="mt-4 text-gray-600 line-clamp-3">{author.bio}</p>
                )}
              </CardContent>
            </Card>
          </div>
        ))}
      </div>
    </div>
  );
}